import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import { IUpdatePaymentQuery } from 'pages/patientReceive/interfaces'

const usePaymentService = () => {
  const { patch } = useAxiosService()

  const updatePaymentStatus = async (query: IUpdatePaymentQuery) => {
    const response: any = await patch(
      `/clinic/booking/update-payment-status`,
      query
    )
    return response as IResponse<any>
  }
  const patchMarkAsPaid = async (bookingId: number) => {
    const response: any = await patch(`/clinic/booking/mark-as-paid`, {
      booking_id: bookingId
    })
    return response as IResponse<any>
  }

  const patchFinishBooking = async (bookingId: number) => {
    const response: any = await patch(`/clinic/booking/finish`, {
      booking_id: bookingId
    })
    return response as IResponse<any>
  }

  return { updatePaymentStatus, patchFinishBooking, patchMarkAsPaid }
}

export default usePaymentService
